import { getService } from 'react-in-angularjs';

export const getIsActivePageByUrl = (url: string): boolean => {
  const $location = getService('$location');

  const currentPage = $location.path();

  const urlPattern = url.replace(/:\w+/g, '[^/]+');

  const pagePattern = new RegExp(`\\${urlPattern}($|\\?)`);

  return pagePattern.test(currentPage);
};
